import { c as _c } from "react/compiler-runtime";
import { FeatureViewed } from '@cc-shopping/platform-analytics/FeatureViewed';
import { Box } from '@mui/material';
import { useCompareContext } from '../../../Context';
import { SearchAutoComplete } from './SearchAutoComplete';
export function CreditCardsCompareSearch() {
  const $ = _c(9);
  const {
    allOffers,
    areSlotsOpen
  } = useCompareContext();
  let t0;
  if ($[0] !== allOffers) {
    t0 = allOffers.map(_temp);
    $[0] = allOffers;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const dataset = t0;
  let t1;
  if ($[2] !== areSlotsOpen) {
    t1 = !areSlotsOpen ? {
      pointerEvents: "none",
      opacity: 0.25
    } : {};
    $[2] = areSlotsOpen;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== dataset) {
    t2 = <SearchAutoComplete dataset={dataset} />;
    $[4] = dataset;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <FeatureViewed entityName="cc_compare_card_impression" entitySection="cc_shopping_product_card_large" impressionPosition={0}><Box sx={t1}>{t2}</Box></FeatureViewed>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
function _temp(offer) {
  return {
    label: offer.name,
    id: offer.id,
    imgSource: offer.imageOptions.large.url
  };
}